import {Button, Chip, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import "../../style/datePicker.css"
import {updatePersonServiceDocumentation} from "../../services/service/service";
import FileInput from "../system/fileInput";
import {ServiceContext} from "../../context/service";

export function PersonServiceDocumentationForm() {

  const {
    service,
    document,
    modalOpen,
    setModalOpen,
    setLastDataRefresh,
    setStep,
    setShow
  } = useContext(ServiceContext);

  const disable = service.status === "finish"

  const handleOpen = () => setModalOpen(!modalOpen);

  const [file, setFile] = useState(document?.file ?? "")

  useEffect(() => {
    setFile(document?.file ?? null)
  }, [document]);

  const save = async () => {
    const data = {
      id: document.id,
      title: document.title,
      service_id: service.id,
      file: file,
    };
    let result;

    if (document.status !== "accepted") {
      result = await updatePersonServiceDocumentation(data);

      if (result.status === 201 || result.status === 202) {
        setLastDataRefresh(Date.now())
        setStep("check")
        setShow(1);
      }
    }
    setStep("check")


  };

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          {document &&
            <Typography>
              {service.agent_name + " " + service.agent_family + " - " + service.field_title + " " + service.branch_title + " ( " + document.title + " )"}
            </Typography>
          }
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="mb-4">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {Dict('title') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {document.title}
              </Typography>
            </div>
          </div>

          <div className="mb-4">
            <div className="flex flex-row">
              <Typography className="flex flex-col ml-2">
                {Dict('description') + ": "}
              </Typography>
              <Typography className="flex flex-col" color="blue-gray">
                {document.description}
              </Typography>
            </div>
          </div>

          <div className="flex flex-col w-full mb-4">
            <FileInput
              label={Dict('upload_file')}
              fileCode={file}
              onChange={(e) => {
                setFile(e.target.files[0]);
              }}/>
            {/*<Validator state={file} rules="required"/>*/}
          </div>

          <div className="flex flex-row">
            <Typography color="blue-gray" className="font-medium ml-2">
              وضعیت مدرک:
            </Typography>
            <Chip className="textRight" variant="ghost"
                  value={Dict(document.status)}
                  color={document.status === "accepted" ? "teal" :
                    document.status === "rejected" ? "red" :
                      document.status === "new" ? "cyan" :
                        document.status === "upload" ? "purple" :
                          "red"}/>
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={() => {
            // handleOpen();
            setStep("check")
          }}>
            <span>انصراف</span>
          </Button>
          {!disable &&
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
          }
        </DialogFooter>
      </Dialog>
    </>
  );
}